import type { PropsWithChildren } from "react";
import { t } from "@/i18n-js/instance";
import { Dropdown } from "@circle-react-shared/uikit/Dropdown";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { useSelectedBlock } from "../Hooks/useBuilderStore";
import { useSelectedBlockActions } from "../Hooks/useSelectedBlockActions";

export interface SidebarActionsProps {}

export const SidebarActions = ({
  children,
}: PropsWithChildren<SidebarActionsProps>) => {
  const { selectedBlock } = useSelectedBlock();
  const options = useSelectedBlockActions();

  const label = t("builder_ui.editor.actions");

  if (!selectedBlock) {
    return null;
  }

  return (
    <Dropdown
      direction="bottom-end"
      menuWrapperClassName="!mt-2"
      buttonClassName="flex items-center h-6 w-6 flex justify-center !rounded-full transition-colors duration-200 hover:bg-tertiary focus-visible:outline-secondary focus-visible:rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:bg-tertiary"
      button={
        <IconButton
          name="20-menu-dots-horizontal"
          iconSize={20}
          buttonSize={28}
          ariaLabel={label}
        />
      }
      options={options}
      dataTestId="builder-ui-sidebar-actions-dropdown"
    >
      {children}
    </Dropdown>
  );
};
